<template>
  <v-container
    v-if="!$apollo.loading && schema"
    fill-height
    fluid
    grid-list-xl
  >
    <v-layout wrap>
      <v-flex
        xs12
        md11
      >
        <v-card>
          <v-flex
            v-if="!$apollo.loading"
            xs12
          >
            <div
              v-for="(field, i) in schema"
              :key="i"
              class="mt-3"
            >
              <NestedField
                :ref="field.key"
                :values="schemaValues"
                :field="field"
              />
            </div>
          </v-flex>

          <v-card-actions>
            <v-spacer />
            <v-btn
              text
              :disabled="loading"
              @click="$emit('closeEditMode', false)"
            >
              {{ $t("globals.cancelButton") }}
            </v-btn>
            <v-btn
              :disabled="loading"
              :loading="loading"
              class="primary"
              @click="save()"
            >
              {{ $t("globals.saveButton") }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { validationMixin } from "vuelidate";
import { mapGetters } from "vuex";

import AFF_PLAN_CONFIG_UPDATE from "@/graphql/mutations/AffPlanConfigUpdate.gql";
import AFF_PLANS_CONFIG_SCHEME_QUERY from "@/graphql/queries/AffPlanConfigSchema.gql";
import AFF_PLANS_CONFIG_QUERY from "@/graphql/queries/AffPlanConfig.gql";
import NestedField from "@/components/core/NestedField.vue";
const isArrayItem = (item) => {
  return item.field === "object" && item.children;
};
export default {
  name: "AffPlanConfig",
  components: {
    NestedField,
  },
  mixins: [validationMixin],
  props: {
    whiteLabelId: {
      type: String,
      required: true,
    },
    planId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      affPlanCustomConfigSchema: {},
      loading: false,
    };
  },
  computed: {
    ...mapGetters("whitelabel", ["getWhiteLabel"]),
    schema() {
      const schema = this.affPlanCustomConfigSchema.custom_config_schema;
      return schema ? JSON.parse(schema) : [];
    },
    schemaValues() {
      return this.affPlanCustomConfig
          ? JSON.parse(this.affPlanCustomConfig.custom_config)
          : {};
    },
  },
  watch: {
    getWhiteLabel() {
      this.$emit("closeEditMode", false);
    },
  },
  mounted() {},
  methods: {
    save() {
      let validated = true;
      let custom_config = null;
      const validateField = (field) => {
        if (field.$v !== undefined) {
          field.$v.$touch();
          if (field.$v.$invalid) {
            validated = false;
            return -1;
          }
        }
      };
      const checkArrayFields = (fields, refs) => {
        return fields.reduce((config, field) => {
          refs[field.key].forEach((ref, ind) => {
            if (!config[ind]) {
              config[ind] = {};
            }
            if(isArrayItem(field)){
              config[ind][field.key] = Object.values(checkFields(field.children, ref.$refs, {}, true));
            }
            else {
              config[ind][field.key] = checkFields(field, ref.$refs[field.key], {}, true);
            }
          });

          return config;
        }, []);
      };
      const checkFields = (schema, refs, config = {}, parentIsArray = false) => {
        const isEmptyCheckbox = (item, field) => {
          return item.field === "checkbox" && field[item.key] == null;
        };
        const getSimpleProperty = (propertyId, field) => {
          return parseFloat(field[propertyId]) || field[propertyId];
        };
        if (Array.isArray(schema)) {
          schema.forEach((field) => {
            if (isArrayItem(field)) {
              config[field.key] = checkArrayFields(
                  field.children,
                  refs[field.key][0].$refs
              );
            }
            else if(refs[field.key] && parentIsArray) {
              refs[field.key].forEach((ref, ind) => {
                config[ind] = config[ind] || {};
                config[ind][field.key] = checkFields(
                    field,
                    ref.$refs[field.key],
                    config
                );
              });
            }
            else {
              config[field.key] = checkFields(
                  field,
                  refs[field.key][0].$refs[field.key],
                  config
              );
            }
          });
        } else {
          if (isEmptyCheckbox(schema, refs)) {
            refs[schema.key] = false;
          }
          validateField(refs);

          return getSimpleProperty(schema.key, refs);
        }
        return config;
      };
      custom_config = JSON.stringify(checkFields(this.schema, this.$refs));

      if (validated) {
        this.loading = true;
        this.$apollo
            .mutate({
              mutation: AFF_PLAN_CONFIG_UPDATE,
              variables: {
                whitelabel_uuid: this.whiteLabelId,
                aff_plan_id: this.planId,
                input: { custom_config },
              },
            })
            .then(() => {
              this.loading = false;
              this.$emit("closeEditMode", true);
            })
            .catch((error) => {
              this.errorHandler(error);
              this.loading = false;
              this.$emit("closeEditMode", true);
            });
      }
    },
  },
  validations() {
    return {};
  },
  apollo: {
    affPlanCustomConfigSchema: {
      fetchPolicy: "no-cache",
      query() {
        return AFF_PLANS_CONFIG_SCHEME_QUERY;
      },
      variables() {
        return {
          whitelabel_uuid: this.whiteLabelId,
          aff_plan_id: this.planId,
        };
      },
      skip() {
        return !this.whiteLabelId && !this.planId;
      },
    },
    affPlanCustomConfig: {
      fetchPolicy: "no-cache",
      query() {
        return AFF_PLANS_CONFIG_QUERY;
      },
      variables() {
        return {
          whitelabel_uuid: this.whiteLabelId,
          aff_plan_id: this.planId,
        };
      },
      skip() {
        return !this.whiteLabelId && !this.planId;
      },
    },
  },
};
</script>
<style lang="scss" scoped></style>
